import apiClient from "../helper/apiClient";
import { get } from "lodash";
import { validateUserKey } from "./validateUserKey";

export default async function getContextsData(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getContexts", {
      params: requestObject,
    });
    const contextsData = get(data, "data", []);
    return contextsData;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
